<template>
  <kendo-window
      ref="kendoWindowRef"
      :title="'사용승인'"
      :modal="true"
      :width="'500px'"
      style="display:none;">
    <template>
      <div class="pop-container">
        <div class="pop-conts">
          <div>
            {{callerUserList.length}}명 대상자가 선택되었습니다.<br/>
            전환하고자 하는 승인 상태를 선택해주세요.
          </div>
          <div class="mgt10">
            <input
                @click="aplYn = 'Y'"
                type="radio"
                id="apl_Y"
                name="aplYn"
                value="apl_Y"
                class="k-radio"
                :checked="true">
            <label for="apl_Y" class="k-radio-label" style="width:70px">승인</label>
            <input
                @click="aplYn = 'N'"
                type="radio"
                id="apl_N"
                name="aplYn"
                value="apl_N"
                class="k-radio">
            <label for="apl_N" class="k-radio-label" style="width:70px">승인 취소</label>
          </div>
          <div class="k-text-center mgt30">
            <button type="button" class="mid_btn orange mr5" @click="changeAplYn">저장</button>
          </div>
        </div>
      </div>
    </template>
  </kendo-window>
</template>

<script>
import ApiConfig from '@/api/api.config'
import ApiUtil from '@/api/api.util'

export default {
  name: 'ChangeAplWindow',
  props : ['callerUserList'],

  data: function() {
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      aplYn: 'Y'

    }
  },
  methods: {
    changeAplYn(){
      const vm = this

      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/caller/changeAplYn.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        aplYn: vm.aplYn,
        callerUserList: vm.callerUserList
      }

      ApiUtil.post(url, param).then(response => {
        if(response.data === undefined || response.data.resultStatus === undefined){
          kendo.alert('정상적으로 처리되지 않았습니다.')
          return
        }
        if (response.data.resultStatus.messageCode !== '2000') {
          kendo.alert(response.data.resultStatus.messageText)
          return
        }
        kendo.alert('상태 전환이 적용되었습니다.')
        vm.$parent.getCallerList()
        vm.$refs.kendoWindowRef.kendoWidget().close()

      })
    },
  },
}
</script>
